(function ($) {
  const svgOk = `
    <svg xmlns="http://www.w3.org/2000/svg" id="Camada_1" version="1.1" viewBox="0 0 1 1" width="17" height="17">
      <defs>
        <style>
          .st0 {
            fill: none;
            stroke: #1e1f1d;
            stroke-miterlimit: 10;
            stroke-width: .07px;
          }
        </style>
      </defs>
      <path class="st0" d="M.91.92H.16v-.22h.39L.09.22.22.08l.47.48V.15h.22v.77Z"/>
    </svg>
  `;

  const spinnerLoading = `
    <span class="loader"></span>
  `;

  const MESSAGES = {
    noVariant: "Escolha um produto com estoque para calcular o frete.",
    invalidCep: "Formato de CEP inválido. Use o formato 12345-678.",
    noRates: "Nenhuma taxa de frete encontrada.",
    cepError: "Erro ao buscar o CEP. Tente novamente.",
    cartAddError: "Erro ao adicionar o produto ao carrinho.",
    cartRemoveError: "Erro ao atualizar o carrinho.",
    shippingCalcError: "Erro ao calcular o frete. Tente novamente.",
    asyncError: "Erro ao buscar as taxas de frete.",
    genericError: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
  };

  const UI = {
    enableButton: () => $(".get-rates").prop("disabled", false).html(svgOk),
    disableButton: () => $(".get-rates").prop("disabled", true).html(spinnerLoading),
    showMessage: (message, type = "error") => {
      const color = type === "success" ? "green" : "red";
      $(`#wrapper-response`).html(`
        <div class="message" style="color: ${color}; margin-top: 10px; font-size: 14px;">
          ${message}
        </div>
      `).fadeIn();
    },
  };

  const log = (message, type = "log") => {
    if (window.debugMode) {
      console[type](message);
    }
  };

  const getFirstAvailableVariantId = () => {
    const variants = $('#product-variants .variant');
    for (let i = 0; i < variants.length; i++) {
      const $variant = $(variants[i]);
      const available = $variant.data('available');
      const quantity = $variant.data('quantity');
      const variantId = $variant.data('id');
      if (available && quantity > 0) {
        return variantId;
      }
    }
    return null;
  };

  const getCartContents = (callback) => {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: callback,
      error: () => {
        UI.showMessage(MESSAGES.genericError);
      },
    });
  };

  const addFakeProductToCart = (variantId, callback) => {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: variantId, quantity: 1 },
      dataType: "json",
      success: callback,
      error: () => {
        UI.showMessage(MESSAGES.cartAddError);
        UI.enableButton();
      },
    });
  };

  const removeFakeProductFromCart = (variantId) => {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { updates: { [variantId]: 0 } },
      dataType: "json",
      success: () => log("Produto fake removido com sucesso.", "info"),
      error: () => {
        UI.showMessage(MESSAGES.cartRemoveError);
      },
    });
  };

  const applyCepMask = () => {
    let timeout;
    $(document).off("input", "#address_zip").on("input", "#address_zip", function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const value = $(this).val().replace(/\D/g, "").substring(0, 8);
        $(this).val(value.replace(/^(\d{5})(\d{0,3})/, "$1-$2"));
      }, 200);
    });
  };

  const fetchProvinceFromZip = (zip, callback) => {
    $.ajax({
      url: `https://viacep.com.br/ws/${zip.replace("-", "")}/json/`,
      method: "GET",
      dataType: "json",
      success: (data) => {
        if (data.erro) {
          UI.showMessage(MESSAGES.cepError);
          callback(null);
        } else {
          callback(data.uf);
        }
      },
      error: () => {
        UI.showMessage(MESSAGES.cepError);
        callback(null);
      },
    });
  };

  const pollForShippingRates = (fakeVariantId, retries = 0, maxRetries = 5) => {
    if (retries >= maxRetries) {
      UI.showMessage(MESSAGES.asyncError);
      UI.enableButton();
      if (fakeVariantId) removeFakeProductFromCart(fakeVariantId);
      return;
    }

    setTimeout(() => {
      $.ajax({
        url: "/cart/async_shipping_rates",
        dataType: "json",
        success: (response) => {
          if (response && response.shipping_rates) {
            displayShippingRates(response.shipping_rates);
            if (fakeVariantId) removeFakeProductFromCart(fakeVariantId);
          } else {
            pollForShippingRates(fakeVariantId, retries + 1);
          }
        },
        error: () => {
          UI.showMessage(MESSAGES.asyncError);
          UI.enableButton();
          if (fakeVariantId) removeFakeProductFromCart(fakeVariantId);
        },
      });
    }, 500);
  };

  const displayShippingRates = (rates) => {
    let responseHTML = "<ul class='shipping-rates-list'>";

if (rates && rates.length > 0) {
  rates.forEach((rate) => {
    let name = rate.name;
    let deliveryDays = rate.delivery_days?.[0] || "N/A";

    // Caso específico para "Local Delivery"
    if (name === "Local Delivery") {
      name = "ENTREGA LOCAL";
      deliveryDays = "1 dia útil";
    } else if (deliveryDays !== "N/A") {
      // Ajusta singular/plural dinamicamente
      deliveryDays = parseInt(deliveryDays) === 1 ? "1 dia útil" : `${deliveryDays} dias úteis`;
    }

    // Ajusta o preço para exibir "GRÁTIS" quando for zero
    const price = parseFloat(rate.price) === 0 
      ? "GRÁTIS" 
      : `R$ ${(parseFloat(rate.price)).toFixed(2).replace(".", ",")}`;

    responseHTML += `
      <li class="shipping-rate-item">
        <div class="shipping-name">${name}</div>
        <div class="shipping-right">
          <div class="shipping-price">${price}</div>
          <div class="shipping-days">${deliveryDays}</div>
        </div>
      </li>
    `;
  });
} else {
      responseHTML += "<li>Nenhuma opção de frete disponível.</li>";
    }

    responseHTML += "</ul>";
    $(`#wrapper-response`).html(responseHTML).fadeIn();
    UI.enableButton();
  };

  const calculateShipping = (address, fakeVariantId = null) => {
    $.ajax({
      type: "POST",
      url: "/cart/prepare_shipping_rates",
      data: $.param({ shipping_address: address }),
      success: () => pollForShippingRates(fakeVariantId),
      error: () => {
        UI.showMessage(MESSAGES.shippingCalcError);
        UI.enableButton();
        if (fakeVariantId) removeFakeProductFromCart(fakeVariantId);
      },
    });
  };

  const initShippingCalculator = () => {
    try {
      applyCepMask();

      $(document).off("click", ".get-rates").on("click", ".get-rates", (e) => {
        e.preventDefault();

        const zip = $("#address_zip").val().trim();
        if (!/^\d{5}-\d{3}$/.test(zip)) {
          UI.showMessage(MESSAGES.invalidCep);
          return;
        }

        UI.disableButton();

        fetchProvinceFromZip(zip, (province) => {
          if (!province) {
            UI.enableButton();
            return;
          }

          getCartContents((cart) => {
            if (cart.items && cart.items.length > 0) {
              calculateShipping({ zip, country: "BR", province });
            } else {
              const variantId = getFirstAvailableVariantId();
              if (!variantId) {
                UI.showMessage(MESSAGES.noVariant);
                UI.enableButton();
                return;
              }

              addFakeProductToCart(variantId, () => {
                calculateShipping({ zip, country: "BR", province }, variantId);
              });
            }
          });
        });
      });
    } catch (err) {
      console.error(err);
      UI.showMessage(MESSAGES.genericError);
    }
  };

  $(document).ready(() => {
    initShippingCalculator();
  });
})(jQuery);